import { development } from './en/development';
import { common } from './en/common';
import { sidebar } from './en/sidebar';
import { auth } from './en/auth';
import { dashboard } from './en/dashboard';
import { products } from './en/products';
import { inventory } from './en/inventory';
import { movements } from './en/movements';
import { reports } from './en/reports';
import { settings } from './en/settings';
import { users } from './en/users';
import { table } from './en/table';

export const en = {
  development,
  common,
  sidebar,
  auth,
  dashboard,
  products,
  inventory,
  movements,
  reports,
  settings,
  users,
  table,
} as const;
